// แบรนด์ที่แสดงใน My Job = แบรนด์ที่ถูก enable จากหน้า Setting → Product
// (สร้างสินค้า/กลุ่มไว้ ≠ แสดงใน My Job — ต้อง enable อีกที)
import type { Brand } from "@contracts/api";
import { api } from "@shared/api/client";

export const brandKeys = {
  all: ["brands"] as const,
  detail: (id: string) => ["brands", id] as const,
};

export async function fetchBrands(): Promise<Brand[]> {
  const { data } = await api.get<Brand[]>("/brands");
  return Array.isArray(data) ? data : [];
}
